<div class="close">
  <button mat-stroked-button mat-dialog-close>この画面を閉じる</button>
</div>
@if (mode() === 'reserve') {
  @if (data.topText) {
<div [innerHtml]="data.topText" class="alert"></div>
  } @else {
<div class="alert">【！】このまま無料カウンセリングに予約すると、<span class="strong"><span>留学支援金10万円キャンペーン</span>の適用が確定</span>します！</div>
  }
<section class="co-callender u-bg2">
  <div class="c-wrapper--medium">
    <h2 class="co-callender__title">カウンセリング方法を選んでください</h2>
    <mat-radio-group [ngModel]="place()" (ngModelChange)="place.set($event)">
      <mat-radio-button value="新宿オフィス"><span class="co-callender__label  u-br-normal u-text-bold">新宿オフィスでの対面相談</span><button class="co-callender__detailBtn u-br-normal" (click)="openMap()">詳細</button></mat-radio-button>
      <mat-radio-button value="オンライン"><span class="co-callender__label u-br-normal u-text-bold">オンライン面談</span></mat-radio-button>
    </mat-radio-group>

    <h2 class="co-callender__title">ご希望の日時をタップしてください</h2>
    @if (schedules().length) {
    <table class="co-callender__table" id="schedules">
      <tbody>
        <tr class="co-callender__dateWrapper">
          <th class="co-callender__date u-text-center"></th>
          @for (date of schedules(); track date) {
          <th class="co-callender__date u-text-center">{{ date.day|date:'M/dd' }}<br class="u-db u-dn-md">({{ date.day|date:'E' }})</th>
          }
        </tr>
        @for (schedule of schedules()[0].schedules; track schedule; let i = $index) {
        <tr class="co-callender__tr">
          <th class="co-callender__time u-text-center">{{ schedule.time|slice:0:5 }}</th>
          @for (date of schedules(); track date) {
          <td class="co-callender__status u-text-center" [class.selected]="selectedDate()?.date === date.day && selectedDate()?.time === schedule.time">
            @if (date.schedules[i].status === '-' || date.schedules[i].status === '×') {
            {{ date.schedules[i].status }}
            } @else if (selectedDate()?.date === date.day && selectedDate()?.time === schedule.time) {
            <a class="co-callender__link u-br-normal" (click)="select(date.day, schedule.time)">選択中</a>
            } @else if (date.schedules[i].status !== '-' && date.schedules[i].status !== '×') {
            <a class="co-callender__link u-br-normal" (click)="select(date.day, schedule.time)">{{ date.schedules[i].status }}</a>
            }
          </td>
          }
        </tr>
        }
      </tbody>
    </table>
    <div class="attention">空席がない場合は<br>「次の1週間」をタップしてご確認ください。</div>
    } @else {
    Loading...
    }
    <div class="co-callender__pnwrapper">
      <a class="co-callender__prev u-br-normal u-text-bold" (click)="prevWeek()" [class.disabled]="!canPrev()">前の1週間</a>
      <a class="co-callender__next u-br-normal u-text-bold" (click)="nextWeek()">次の1週間</a>
    </div>
  </div>
</section>
<div class="u-text-center">
  <div class="co-form__privacy">
    <input type="checkbox" id="agree" name="checkbox01" [formControl]="form.controls.agree"><label for="agree"></label><span><a href="https://ryugaku.yume-kana.com/policy/" target="_blank" rel="noopener noreferrer">利用規約・プライバシーポリシー</a>に同意の上</span>
  </div>
  @if (form.controls.agree.touched && form.controls.agree.hasError('required')) {
  <mat-error>利用規約・プライバシーポリシーへの同意は必須です</mat-error>
  }

  <button class="co-form__btn u-br-normal c-btn c-btn--ac1" type="button" name="submitConfirm" value="無料カウンセリングを予約する" (click)="submit()" [disabled]="sending()">無料カウンセリングを予約して<br>支援金10万円を受け取る</button>
</div>
} @else if (mode() === 'complete') {
  <div class="alert">無料カウンセリングの予約が完了しました！</div>
  <div class="u-text-center">
    <p>ご予約内容をメールでお送りしました。<br>ご確認ください。</p>
    <button mat-stroked-button mat-dialog-close>閉じる</button>
  </div>
}

